import React from "react";
import { 
  Container, 
  Box, 
  Typography, 
  Grid, 
  Link, 
  useMediaQuery,
  useTheme as useMuiTheme
} from "@mui/material";
import { useTheme } from "../../context/ThemeContext";

const services = [

  {
    src: "/images/logo512.png",
    alt: "Get Id",
    link: "https://keypairs.freeweb3.com",
    label: "Get Web3 Id",
  },
  {
    src: "/images/logo512.png",
    alt: "Upload a Public File",
    link: "https://upload.freeweb3.com",
    label: "Upload a Public File",
  },
  {
    src: "/images/logo512.png",
    alt: "Encrypt Image to Blob Storage",
    link: "https://upload-encrypted.freeweb3.com/",
    label: "Encrypt Image to Blob Storage",
  },
  {
    src: "/images/logo512.png",
    alt: "Unified Evidencer",
    link: "https://unified.evidencer.io/",
    label: "Unified Evidencer",
  },
  {
    src: "/images/logo512.png",
    alt: "Create a Claim",
    link: "https://artifacts.evidencer.io",
    label: "Create a Claim",
  },

];

const Footer = () => {
  const { themeMode } = useTheme();
  const muiTheme = useMuiTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down("sm"));
  
  const bgColor = themeMode === "light" 
    ? muiTheme.palette.grey[200] 
    : muiTheme.palette.grey[900];
    
  const serviceBgColor = themeMode === "light" 
    ? muiTheme.palette.grey[300] 
    : muiTheme.palette.grey[800];

  return (
    <Box component="footer" sx={{ mt: 4 }}>
      {/* Services Section */}
      <Box py={4} bgcolor={serviceBgColor}>
        <Container maxWidth="lg">
          <Typography variant="h5" gutterBottom align="center" sx={{ mb: 3 }}>
            Our Services
          </Typography>
          
          <Grid container spacing={2} justifyContent="center">
            {services.map((service, index) => (
              <Grid item xs={6} sm={4} md={3} lg={2} key={index}>
                <Box 
                  sx={{
                    textAlign: "center",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-5px)",
                    },
                  }}
                >
                  <Link
                    href={service.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    underline="none"
                  >
                    <Box
                      sx={{
                        position: "relative",
                        display: "inline-block",
                        mb: 1,
                        "&:hover img": {
                          transform: "scale(1.1)",
                          transition: "transform 0.3s ease",
                        },
                      }}
                    >
                      <img
                        src={service.src}
                        alt={service.alt}
                        style={{
                          width: isMobile ? "80px" : "100px",
                          height: "auto",
                          transition: "transform 0.3s ease",
                        }}
                      />
                    </Box>
                    <Typography 
                      variant="caption" 
                      display="block"
                      sx={{ 
                        color: themeMode === "light" ? "text.primary" : "text.secondary"
                      }}
                    >
                      {service.label}
                    </Typography>
                  </Link>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Copyright Section */}
      <Box py={3} bgcolor={bgColor}>
        <Container maxWidth="lg">
          <Grid container spacing={2} alignItems="center" justifyContent="space-between">
            <Grid item xs={12} sm={4} sx={{ textAlign: { xs: "center", sm: "left" } }}>
              <img
                src="https://zpl0eg1fzvvynkgt.public.blob.vercel-storage.com/w3le-200w-jWDyOUJ8HoreMXISAEGro21IZhF2hq.png"
                alt="Evidencer Logo"
                style={{ maxWidth: "100px", height: "auto" }}
              />
            </Grid>
            
            <Grid item xs={12} sm={4} sx={{ textAlign: "center" }}>
              <Typography variant="body2">
                ©2025 <Box component="span" sx={{ fontWeight: "bold" }}>Web3 Legal Engineering</Box>
              </Typography>
            </Grid>
            
            <Grid item xs={12} sm={4} sx={{ textAlign: { xs: "center", sm: "right" } }}>
              <Link href="/documentation.html" sx={{ mx: 1 }}>
                Documentation
              </Link>
              <Link href="https://terms.freeweb3.com" target="_blank" rel="noopener noreferrer" sx={{ mx: 1 }}>
                Privacy Policy
              </Link>
              <Link href="https://terms.freeweb3.com" target="_blank" rel="noopener noreferrer" sx={{ mx: 1 }}>
                Terms of Service
              </Link>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default Footer;